import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import border from '../../tokens/border'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'

export const ButtonUpload = styled.button.attrs((props) =>
  composeTheme(props),
)<{ child?: any }>`
  background: transparent;
  border: none;
  color: ${(props) => !props.child && props.theme.brandColors.primaryPure};
  cursor: pointer;
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  font: inherit;
  letter-spacing: 0em;
  line-height: 2.8rem;
  line-height: normal;
  margin: ${layout.margin.spacingNone};
  overflow: visible;
  padding: ${layout.padding.spacingInsetNone};
  text-align: center;
  text-decoration: ${(props) => !props.child && 'underline'};
  width: auto;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  -webkit-font-smoothing: inherit;
  padding-bottom: ${layout.margin.spacingNano};

  &:focus {
    outline: none;
  }
`

export const Wrapper = styled.div.attrs((props) => composeTheme(props))<{
  type: string
}>`
  height: 15rem;
  border: ${border.width.widthThin}
    ${(props) =>
      props.type === 'set'
        ? props.theme.brandColors.primaryPure
        : colors.neutralColorLowLight}
    dashed;
  border-radius: 0.8rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.type === 'set' ? 'inherit' : 'pointer')};
`

ButtonUpload.defaultProps = defaultTheme
Wrapper.defaultProps = defaultTheme
